import "./styles/Home.css"; // Retain the legacy cascade for routes outside the prototype.
import FeaturedProducts from "../Components/modern/FeaturedProducts";
import ImpactSection from "../Components/modern/ImpactSection";
import LogoStrip from "../Components/modern/LogoStrip";
import {
  Container,
  SectionHeading,
  Eyebrow,
  ButtonLink,
  Arrow,
} from "../Components/modern/UI";
import heroPhoto from "../Images/client/field/woman-operating-weeder.jpg";
import sw4Photo from "../Images/client/field/sw4.jpeg";
import { partners, supporters } from "../Components/modern/clientLogos";
import { Link } from "react-router-dom";

function Hero() {
  return (
    <section
      aria-labelledby="sn-hero-title"
      className="sn-pb-12 sn-pt-8 md:sn-pb-16 md:sn-pt-12"
    >
      <Container>
        <div className="sn-grid sn-gap-10 lg:sn-grid-cols-[1.12fr_1fr] lg:sn-items-stretch lg:sn-gap-12">
          <div className="sn-flex sn-h-full sn-flex-col sn-justify-center sn-rounded-card sn-bg-cream">
            <Eyebrow>Electric by design. Sustainable by Nature</Eyebrow>
            <h1
              id="sn-hero-title"
              className="sn-hero-title sn-font-display sn-text-forest"
            >
              Lighter Tools.
              <br />
              Herbicide-free Fields.
              <br />
              <span className="sn-text-leaf">Stronger Farmers.</span>
            </h1>
            <p className="sn-mt-6 sn-max-w-lg sn-text-base sn-leading-relaxed sn-text-muted">
              Battery-powered, women-friendly machines built to end drudgery
              and chemical dependence in Indian agriculture.
            </p>
            <div className="sn-mt-8 sn-flex sn-flex-col sn-gap-3 sm:sn-flex-row">
              <ButtonLink to="/products">Explore Our Machines</ButtonLink>
              <ButtonLink to="/about" variant="secondary">
                Discover Our Story
              </ButtonLink>
            </div>
          </div>
          <figure className="sn-relative sn-h-full">
            <div className="sn-h-full sn-overflow-hidden sn-rounded-card sn-bg-sage">
              <img
                src={heroPhoto}
                alt="Woman operating a weeding machine in a cultivated field"
                width="3050"
                height="2160"
                fetchpriority="high"
                className="sn-h-full sn-min-h-[360px] sn-photo sn-w-full sn-object-cover sn-object-left"
              />
            </div>
          </figure>
        </div>
      </Container>
    </section>
  );
}
function Introduction() {
  return (
    <section
      aria-labelledby="sn-about-title"
      className="sn-border-t sn-border-line sn-bg-sage/50 sn-py-14 md:sn-py-20"
    >
      <Container className="sn-grid sn-gap-8 md:sn-grid-cols-[0.9fr_1.1fr] md:sn-items-stretch md:sn-gap-12 lg:sn-gap-20">
        <figure className="sn-overflow-hidden sn-rounded-card sn-bg-white sn-shadow-soft md:sn-relative md:sn-h-full">
          <img
            src={sw4Photo}
            alt="Single Wheel Weeder being used in a crop field"
            width="960"
            height="1280"
            loading="lazy"
            className="sn-h-auto sn-w-full sn-object-cover sn-object-[50%_44%] sn-photo md:sn-absolute md:sn-inset-0 md:sn-h-full"
          />
        </figure>
        <div className="sn-flex sn-h-full sn-flex-col sn-justify-center">
          <SectionHeading id="sn-about-title" eyebrow="Why Suryanirbhar">
            Less effort in the field.
            <br />
            More possibility.
          </SectionHeading>
          <p className="sn-mt-6 sn-text-base sn-leading-relaxed sn-text-muted">
            Suryanirbhar Agritech designs and manufactures battery-operated
            farm equipment, especially weeders for paddy, field crops, and
            plantation crops, along with a purpose-built electric poultry raking
            machine. The company replaces fuel-driven and manual farm equipment
            with electric alternatives that cut running costs, remove dependence
            on petrol/diesel, and reduce the drudgery of manual weeding and
            poultry litter management.
          </p>
          <Link
            to="/about"
            className="sn-mt-5 sn-inline-flex sn-min-h-[44px] sn-items-center sn-gap-5 sn-text-sm sn-font-semibold sn-text-forest"
          >
            Get to know Suryanirbhar
            <Arrow />
          </Link>
        </div>
      </Container>
    </section>
  );
}
export default function Home() {
  return (
    <>
        <Hero />
        <Introduction />
        <FeaturedProducts />
        <ImpactSection />
        <div className="sn-bg-white sn-py-8 md:sn-py-12">
          <Container className="sn-grid sn-gap-x-16 md:sn-grid-cols-2">
            <LogoStrip title="Supported by" logos={supporters} />
            <LogoStrip title="Partnerships" logos={partners} />
          </Container>
        </div>
    </>
  );
}
